import { Rendition } from "@omni/types/components/image/rendition.type";
import { isDefined } from "@omni/utils/helper.utils";

import { RenderImage } from "../types/renderImage.type";

const getEmptyImageSrc = (width: number, height: number) => {
    const svg = `<?xml version="1.0" encoding="UTF-8" ?><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 ${width} ${height}"><rect x="0" y="0" width="10" height="10" style="fill:white;fill-opacity:0" /></svg>`;
    const base64 = btoa(svg);

    return `data:image/svg+xml;base64,${base64}`;
};

const toSrcSet = (renditions: Array<Rendition>) => {
    return renditions
        .map((rendition) => `${rendition.source} ${rendition.width}w`)
        .join(" ,");
};

type GetRenderImage = (props: {
    src?: string;
    renditions?: Array<Rendition>;
    width?: string | number;
    height?: string | number;
}) => RenderImage | undefined;

export const getRenderImage: GetRenderImage = ({
    src,
    renditions,
    width,
    height
}) => {
    if (!src && !renditions) return;

    const srcSet = isDefined(renditions) ? toSrcSet(renditions) : undefined;

    const parsedWidth = Number(width);
    const parsedHeight = Number(height);

    const emptySrc =
        isDefined(srcSet) &&
        !Number.isNaN(parsedWidth) &&
        !Number.isNaN(parsedHeight)
            ? getEmptyImageSrc(parsedWidth, parsedHeight)
            : undefined;

    return {
        src: emptySrc || src,
        srcSet: srcSet,
        width: !Number.isNaN(parsedWidth) ? parsedWidth : undefined,
        height: !Number.isNaN(parsedHeight) ? parsedHeight : undefined
    };
};
